import { render, staticRenderFns } from "./OrderTypes.vue?vue&type=template&id=552026ea&scoped=true&"
import script from "./OrderTypes.vue?vue&type=script&lang=js&"
export * from "./OrderTypes.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypes.vue?vue&type=style&index=0&id=552026ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552026ea",
  null
  
)

export default component.exports